import { urls } from 'src/urls/workspaces';
import { authRequest, jsonHeaders } from 'src/utils/fetch';

import { WorkspaceAiPreferenceResourceDataType } from '.';

export type AiPreferencesCalloutInput = Partial<
  Omit<WorkspaceAiPreferenceResourceDataType, 'aiEnabled'>
>;

export function getAiPreferencesCallout(workspaceSlug: string) {
  return async function (options: Partial<AiPreferencesCalloutInput>) {
    const response = await fetch(
      authRequest(urls.api.internal.atlassianIntelligencePrefs(workspaceSlug), {
        method: 'PUT',
        headers: jsonHeaders,
        body: JSON.stringify(options),
      })
    );

    return response;
  };
}

export function genAtlassianIntelligenceCallout({
  workspaceSlug,
}: {
  workspaceSlug: string;
}) {
  return async function (isAiEnabled: boolean) {
    const getBodyString = () => {
      if (!isAiEnabled) {
        return undefined;
      }

      return JSON.stringify(['aiMlPolicyTermsOfUse']);
    };

    const url = urls.api.internal.atlassianIntelligence(workspaceSlug);
    const response = await fetch(
      authRequest(url, {
        method: isAiEnabled ? 'PUT' : 'DELETE',
        headers: jsonHeaders,
        body: getBodyString(),
      })
    );
    return response;
  };
}
